import { createContext, useContext, useState, useMemo } from "react";

// Create the Snackbar Context
const SnackbarContext = createContext();

// SnackbarProvider Component to manage Snackbar state
export const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "Success",
    severity: "success",
    duration: 5000,
    anchorOrigin: { vertical: "bottom", horizontal: "center" },
    customColors: {},
  });

  // Update the Snackbar state
  const updateSnackbar = (newState) => {
    setSnackbarState((prevState) => ({
      ...prevState,
      ...newState,
      open: true, // Always set open to true when updating
    }));
  };

  // Close the Snackbar
  const closeSnackbar = () => {
    setSnackbarState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  // Memoize the context value to avoid unnecessary re-renders
  const contextValue = useMemo(
    () => ({ snackbarState, updateSnackbar, closeSnackbar }),
    [snackbarState, updateSnackbar, closeSnackbar]
  );
  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
    </SnackbarContext.Provider>
  );
};

// Custom hook to use Snackbar context
export const useSnackbar = () => useContext(SnackbarContext);
